import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Icon from './Icon';
import styled, { css } from 'styled-components';
import {toggleTooltip} from '../lib/utils';

const whiteStyles = `
width: 100%;
margin: 2% 0;
box-shadow: 0 0 10px 2px rgba(0, 0, 0, .05);
> div {
  background: #fff;
  > i {
    width: 15px;
    height: 15px;
    > svg g {
      stroke: none;
      fill: #eee;
    }
  }
  > span {
    color: #333;
  }
}
@media (min-width: 1024px) {
  margin: 1% 0;
}
`;

const StyledPropertyListed = styled.div`
  width: 96%;
  margin: 8px 2%;
  border-radius: 10px;
  background-color: rgba(51, 51, 51, ${props => props.selected ? ".5" : "1"});
  box-shadow: 0 0 20px 5px rgba(0, 0, 0, .15);
  height: 60px;
  text-align: center;
  padding: 16px;
  position: relative;
  > div {
    padding: 0 60px;
    width: 100%;
    position: absolute;
    left: 0;
    height: 100%;
    top: 0;
    > i {
      position: absolute;
      width: 30px;
      height: 30px;
      left: 20px;
      top: 50%;
      opacity: ${props => !props.white && props.selected ? ".5" : "1"};
      transform: translateY(-50%);
    }
    > span,
    button {
      font-size: .625em;
      letter-spacing: .5px;
      line-height: 1.6;
    }
    > span {
      color: #BBB;
      cursor: default;
      text-transform: uppercase;
      opacity: ${props => props.selected ? ".5" : "1"};
      display: block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      padding: ${props => props.selected ? "0 88px 0 60px" : "0 60px"};
      text-align: left;
    }
    button {
      position: absolute;
      background: ${props => props.selected ? "transparent" : props.white ? "#333" : props.theme.blueBright};
      color: ${props => props.white ? "#333" : "#bbb"};
      width: ${props => props.selected ? "auto" : "20px"};
      height: 20px;
      right: ${props => props.selected ? "15px" : "25px"};
      top: 50%;
      transform: translateY(-50%);
      text-transform: uppercase;
      padding: 0;
      i {
        margin: 0;
        width: 8px;
        height: 8px;
        margin: 0 auto;
        svg {
          stroke: #fff;
        }
      }
    }
  }

  & {
    ${props => props.white ? css`${whiteStyles}` : ''}
  }
`;

export default function PropertyListed (props) {
  const {data, toggle, white, draggable, selected} = props;
  const {key, label, type} = data || {};
  return (
    <StyledPropertyListed white={white} selected={selected}>
      <div>
        <Icon name={draggable ? "menu" : type==="physical" ? "range-control" : "radial-control"}/>
        {label &&
        <span
          onMouseOver={(e) => toggleTooltip(e, {label})}
          onMouseOut={(e) => toggleTooltip()}
        >{label}</span>}
        {selected ? (
          <Button transparent label={"remove (-)"} onClick={() => toggle(key)}/>
        ) : (
          <Button round icon="add" onClick={() => toggle(key)}/>
        )}
      </div>
    </StyledPropertyListed>)
}

PropertyListed.propTypes = {
  icon: PropTypes.string,
};
